import { render, staticRenderFns } from "./Teamlist.vue?vue&type=template&id=ddaf977a&scoped=true&"
import script from "./Teamlist.vue?vue&type=script&lang=js&"
export * from "./Teamlist.vue?vue&type=script&lang=js&"
import style0 from "./Teamlist.vue?vue&type=style&index=0&id=ddaf977a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaf977a",
  null
  
)

export default component.exports